import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 create_promotion_draw: { message: "idle" },
};

export const create_promotion_draw_Slice = createSlice({
 name: "create_promotion_draw",
 initialState,
 reducers: {
  success_create_promotion_draw: (state, action) => {
   state.create_promotion_draw = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_create_promotion_draw: (state, action) => {
   state.create_promotion_draw = { status: app_consts.FAIL, message: action.payload };
  },
  reset_create_promotion_draw: (state) => {
   state.create_promotion_draw = { status: app_consts.IDLE };
  },
  loading_create_promotion_draw: (state) => {
   state.create_promotion_draw = { status: app_consts.LOADING };
  },
 }
});

export const { success_create_promotion_draw, fail_create_promotion_draw, reset_create_promotion_draw, loading_create_promotion_draw } = create_promotion_draw_Slice.actions;

export default create_promotion_draw_Slice.reducer;